import axios from 'axios';

const API_URL = 'https://g5f95xextg.execute-api.us-east-1.amazonaws.com/Dev';

export const checkUserAccess = async (email) => {
  try {
    const response = await axios.get(`${API_URL}/auth/check-access?email=${email}`);
    
    // The API returns an object with a body property containing a JSON string
    // We need to parse this JSON string to get the actual user data
    if (response.data && response.data.body) {
      let userData;
      
      // If body is a string, parse it
      if (typeof response.data.body === 'string') {
        userData = JSON.parse(response.data.body);
      } else {
        // If it's already an object, use it as is
        userData = response.data.body;
      }
      
      return { 
        success: true,
        data: userData
      };
    }
    
    return { 
      success: false, 
      error: 'Invalid response format from server' 
    };
  } catch (error) {
    return { 
      success: false, 
      error: error.response?.data?.message || 'Error checking user access' 
    };
  }
};

export const registerUser = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/auth/check-access`, userData);
    
    // Handle the same response format for registration
    if (response.data && response.data.body) {
      let responseData;
      
      if (typeof response.data.body === 'string') {
        responseData = JSON.parse(response.data.body);
      } else {
        responseData = response.data.body;
      }
      
      return { 
        success: true, 
        data: responseData 
      };
    }
    
    return { 
      success: false, 
      error: 'Invalid response format from server' 
    };
  } catch (error) {
    return { 
      success: false, 
      error: error.response?.data?.message || 'Error registering user' 
    };
  }
};
